import { Navigate } from "react-router-dom";

export default function VerifyOtpProtectedRoute({ children }) {
    const allowed = sessionStorage.getItem("otp_allowed");

    return allowed === "true" ? children : <Navigate to="/forgot-password" />;
}
